module.exports = __webpack_public_path__ + "img/tree-fire-flame-03-b.a5ae47af.png";